import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const useProgress = (): number => {
  const { pathname } = useLocation();

  const [progress, setProgress] = useState(() => pathnameToProgress(pathname));

  useEffect(() => {
    setProgress(pathnameToProgress(pathname));
  }, [pathname]);

  return progress;
};

const pathnameToProgress = (pathname: string) => {
  if (pathname === '/first-loan/register') return 0.33;

  if (pathname === '/first-loan/questionnaire') return 0.33;

  if (pathname === '/first-loan/welcome-back') return 0.33;

  if (pathname === '/first-loan/identification-method') return 0.66;

  if (pathname === '/first-loan/tink') return 0.66;

  if (pathname === '/first-loan/tink-loading') return 0.66;

  return 1;
};

export default useProgress;
